import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

const STORAGE_KEY = 'rsm-dark-mode';

/**
 * Controla o atributo `data-theme` no <html>, que ativa os overrides
 * declarados em theme/_rsm-tokens-dark.scss.
 *
 * A preferência do usuário é persistida em localStorage. Em uma futura
 * iteração: aceitar `prefers-color-scheme` do SO como default.
 */
@Injectable({ providedIn: 'root' })
export class DarkModeService {
  private readonly darkSubject = new BehaviorSubject<boolean>(false);
  readonly dark$: Observable<boolean> = this.darkSubject.asObservable();

  /** Aplica o estado salvo no localStorage. Chamar uma vez no AppComponent.ngOnInit. */
  init(): void {
    const stored = localStorage.getItem(STORAGE_KEY);
    this.setDark(stored === 'true');
  }

  toggle(): void {
    this.setDark(!this.darkSubject.value);
  }

  setDark(enabled: boolean): void {
    const html = document.documentElement;
    if (enabled) {
      html.setAttribute('data-theme', 'dark');
    } else {
      html.removeAttribute('data-theme');
    }
    localStorage.setItem(STORAGE_KEY, String(enabled));
    this.darkSubject.next(enabled);
  }

  isDark(): boolean {
    return this.darkSubject.value;
  }
}
